

import React from 'react';

const EdgeLegend: React.FC = () => {
    return (
        <div style={{ 
            display: 'flex', 
            gap: 16, 
            flexWrap: 'wrap',
            padding: '12px',
            background: '#f9fafb',
            borderRadius: 6,
            fontSize: 12
        }}>
            {/* Исходящее → Исходящее - синий */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{ width: 20, height: 3, background: '#4A90E2' }}></div>
                <span>Исходящее → Исходящее</span>
            </div>

            {/* Входящее → Входящее - зеленый */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{ width: 20, height: 3, background: '#52C41A' }}></div>
                <span>Входящее → Входящее</span>
            </div>

            {/* Исходящее → Входящее - фиолетовый */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{ width: 20, height: 3, background: '#722ED1' }}></div>
                <span>Исходящее → Входящее</span>
            </div>

            {/* Входящее → Исходящее - оранжевый */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{ width: 20, height: 3, background: '#FA8C16' }}></div>
                <span>Входящее → Исходящее</span>
            </div>

            {/* Другие связи - серый */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{ width: 20, height: 3, background: '#8C8C8C' }}></div>
                <span>Другие связи</span>
            </div>

            {/* Подсказка о перемещении */}
            <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 6, 
                marginLeft: 'auto',
                color: '#6b7280',
                fontSize: 14,
                fontStyle: 'italic'
            }}>
                <span>💡 Блоки можно перемещать мышью</span>
            </div>
        </div>
    );
};

export default EdgeLegend;

